import { Button } from "@alternative/components";
import React from "react";
import { useRecoilState } from "recoil";
import { duplicateEntryTypes, uploadErrStatus } from "../../constants";
import { dialogState } from "../../recoil/filemanager/atoms";
import Dialog from "./Dialog";

export const DuplicateEntryDialog = (props) => {
  const { isOpen, entryType, items, onClose, onMerge, onRename, onReplace } = props;
  const renderMessage = () => {
    switch (entryType) {
      case duplicateEntryTypes.FILE:
        return (
          <>
            <p>These files already exist in the destination:</p>
            <ul className="at-dialog-filelist">
              {items.map((item) => (
                <li>{item.filename}</li>
              ))}
            </ul>
          </>
        );
      case duplicateEntryTypes.FOLDER:
        return (
          <p>
            A folder named "{items[0].name}" already exists <br /> in the destination
          </p>
        );
      default:
        return <></>;
    }
  };
  return (
    <Dialog
      {...props}
      isOpen={isOpen}
      onClose={onClose}
      header={`Duplicate ${entryType === duplicateEntryTypes.FILE ? "files" : "folder"} found`}
    >
      <div className="at-dialog__body">{renderMessage()}</div>
      <div className="at-dialog__footer">
        {/* {entryType === duplicateEntryTypes.FOLDER && (
          <Button text="Merge" intent="primary" tertiary onClick={onMerge} />
        )} */}
        <Button text="Rename" intent="primary" tertiary onClick={onRename} />
        <Button text="Replace" intent="primary" tertiary onClick={onReplace} />
      </div>
      <span className="at-text-small">Close this dialog to skip</span>
    </Dialog>
  );
};
export const UploadErrorDialog = (props) => {
  const { isOpen, status, items, onClose } = props;
  const renderMessage = () => {
    switch (status) {
      case uploadErrStatus.NO_INTERNET:
        return "Please check your internet connection and try again.";
      case uploadErrStatus.CTF_MISMATCH:
        return "Make sure the CTF passwords are correct and try again.";
      case uploadErrStatus.SERVICE_FAILURE:
      default:
        return <></>;
    }
  };
  const renderButtons = () => {
    switch (status) {
      case uploadErrStatus.NO_INTERNET:
        return (
          <>
            <Button text="Retry" intent="primary" />
            <Button text="Cancel" intent="primary" tertiary />
          </>
        );
      case uploadErrStatus.CTF_MISMATCH:
      case uploadErrStatus.SERVICE_FAILURE:
      default:
        return (
          <>
            <Button text="Ok" intent="primary" tertiary />
          </>
        );
    }
  };
  return (
    <Dialog {...props} header="Unable to upload files" isOpen={isOpen} onClose={onClose}>
      <div className="at-dialog-body">
        <p className="at-dialog-message">{renderMessage()}</p>
        <p>These files were not uploaded:</p>
        <ul className="at-dialog-filelist">
          {items.map((item, i) => (
            <li key={i}>{item.filename}</li>
          ))}
        </ul>
        <div className="at-dialog__footer">{renderButtons()}</div>
      </div>
    </Dialog>
  );
};

export const DeleteEntryDialog = (props) => {
  const { isOpen, items, onClose, onDelete } = props;
  return (
    <Dialog {...props} header="Delete files?" isOpen={isOpen} onClose={onClose}>
      <div className="at-dialog__body">
        <p className="at-dialog-message">
          These files will be deleted <strong>forever:</strong>
        </p>
        <ul className="at-dialog-filelist">
          {items.map((item, i) => (
            <li key={i}>{item.filename}</li>
          ))}
        </ul>
        <div className="at-dialog__footer">
          <Button text="Delete" intent="warning" onClick={onDelete} />
          <Button text="Cancel" intent="primary" tertiary onClick={onClose} />
        </div>
      </div>
    </Dialog>
  );
};
